var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-bg learn-app base-container"},[_c('div',[_vm._v("Augaben abgeschlossen !")]),_c('router-link',{attrs:{"to":{name:'traineeLearningStart'}}},[_vm._v("Weiter lernen")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }